/* eslint-disable indent */
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React, { createContext, useContext, useEffect, useState } from 'react';

export const ThemeTypeContext = createContext({});

export const useThemeType = () => {
  return useContext(ThemeTypeContext);
};

export const ThemeTypeProvider = ({ children }) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useTheme();
  const biggerScreen = useMediaQuery(theme.breakpoints.up('md'));
  const [noOfRender, setNoOfRender] = useState(0);

  const [themeType, setThemeType] = useState(
    localStorage.getItem('prefTheme')
      ? localStorage.getItem('prefTheme')
      : prefersDarkMode
      ? 'dark'
      : 'light'
  );
  const [drawerState, setDrawerState] = useState(biggerScreen);

  const switchThemeType = () => {
    localStorage.setItem('prefTheme', themeType === 'light' ? 'dark' : 'light');
    setThemeType(themeType === 'light' ? 'dark' : 'light');
  };

  const toggleDrawer = () => {
    setDrawerState(!drawerState);
  };

  useEffect(() => {
    if (noOfRender < 2) {
      setNoOfRender(noOfRender + 1);
      return;
    }
    setThemeType(prefersDarkMode ? 'dark' : 'light');
  }, [prefersDarkMode]);

  useEffect(() => {
    setDrawerState(biggerScreen);
  }, [biggerScreen]);

  const contextValue = {
    themeType,
    switchThemeType,
    setThemeType,
    drawerState,
    toggleDrawer,
    setDrawerState,
  };

  return (
    <ThemeTypeContext.Provider value={contextValue}>
      {children}
    </ThemeTypeContext.Provider>
  );
};

export const ThemeTypeProviderConsumer = ThemeTypeContext.Consumer;
